import { render } from "./FormTransfer.vue?vue&type=template&id=0ad2f528&scoped=true"
import script from "./FormTransfer.vue?vue&type=script&lang=js"
export * from "./FormTransfer.vue?vue&type=script&lang=js"

import "./FormTransfer.vue?vue&type=style&index=0&id=0ad2f528&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad2f528"]])

export default __exports__